import React from 'react';
import { Container, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import HomeNavbar from './HomeNavbar';
import BuyerNavbar from './BuyerNavbar';
import SellerNavbar from './SellerNavbar';
import AdminNavbar from './AdminNavbar';
import Footer from './Footer';
import logoImage from '../../assets/logo.png';
import './Navbar.css';

const Layout = ({ children, navbarVariant = 'default', showFooter = true }) => {
  const { currentUser, userRole } = useAuth();

  // Determine which navbar to show based on user role
  const renderNavbar = () => {
    if (navbarVariant === 'minimal') {
      return (
        <Navbar expand="lg" className="navbar-shadow navbar-gradient">
          <Container className="position-relative d-flex align-items-center">
            <Navbar.Brand as={Link} to="/" className="navbar-brand-container" style={{ flex: '0 0 auto' }}>
              <div className="d-flex align-items-center">
                <img
                  src={logoImage}
                  alt="UniTrade Logo"
                  className="navbar-logo"
                />
                <span className="brand-text">UniTrade</span>
              </div>
            </Navbar.Brand>
          </Container>
        </Navbar>
      );
    }

    if (!currentUser) {
      return <HomeNavbar />;
    }

    switch (userRole) {
      case 'admin':
        return <AdminNavbar />;
      case 'seller':
        return <SellerNavbar />;
      case 'buyer':
        return <BuyerNavbar />;
      default:
        return <HomeNavbar />;
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      {renderNavbar()}
      <Container className="flex-grow-1 py-4">
        {children}
      </Container>
      {showFooter ? <Footer /> : null}
    </div>
  );
};

export default Layout;
